<template>
  <footer class="bg-gray-100 border-t border-gray-200 w-full mt-auto">
    <div class="max-w-5xl mx-auto px-4 py-4 text-center">
      <nav class="flex flex-wrap justify-center gap-x-3 gap-y-1.5 text-xs text-gray-600 mb-2" :aria-label="$t('navigation.legalLinksAria')">
        <router-link to="/" class="hover:text-indigo-600 transition-colors">{{ $t('navigation.contracts') }}</router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/sobre-nosotros" class="hover:text-indigo-600 transition-colors">{{ $t('navigation.aboutUs') }}</router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/contacto" class="hover:text-indigo-600 transition-colors">{{ $t('navigation.footer.contact') }}</router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/privacy-policy" class="hover:text-indigo-600 transition-colors">
          {{ $t('navigation.footer.privacyPolicy') }}
        </router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/terms" class="hover:text-indigo-600 transition-colors">
          {{ $t('navigation.footer.terms') }}
        </router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/cookies" class="hover:text-indigo-600 transition-colors">
          {{ $t('navigation.footer.cookies') }}
        </router-link>
        <span class="text-gray-300" aria-hidden="true">|</span>
        <router-link to="/aviso-legal" class="hover:text-indigo-600 transition-colors">{{ $t('navigation.legalNotice') }}</router-link>
      </nav>
      <p class="text-xs text-gray-400">
        {{ $t('navigation.footer.copyright') }}
        ·
        <a href="mailto:hola@coolliving.io" class="hover:text-indigo-600 transition-colors">hola@coolliving.io</a>
      </p>
    </div>
  </footer>
</template>

<script setup>
</script>
